import React from "react";

import { IoIosAddCircleOutline } from "react-icons/io";

// CSS File 
import '../../../assets/css/Toasters.css';

const ItemAddedToaster = ({item}) => {

    return (

        <div className="added-checklist-section-component-container">

            <div className="added-checklist-section-container">

                <div className="added-checklist-section-tick-container">

                    <IoIosAddCircleOutline className="added-checklist-section-tick" />
                    
                </div>

                <div className="added-checklist-section-text-container">

                    <div>
                        <p> {item}  </p>
                    </div>

                </div>

            </div>

        </div>
    )
}

export default ItemAddedToaster